<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="560px"
    :close-on-click-modal="false"
    append-to-body
    @update:visible="$emit('update:visible', $event)"
  >
    <div v-loading="loading">
      <el-alert type="info" :closable="false" show-icon class="tip">
        <template slot="title">
          这里是<b>完整明文</b>，打开本框已在服务端记录一条日志（操作人、时间）。
        </template>
      </el-alert>

      <el-form :model="form" label-width="90px" size="small">
        <el-form-item label="姓名">
          <el-input v-model="form.real_name" placeholder="需与身份证一致" />
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="form.id_card" placeholder="大陆身份证 / 港澳台证件 / 护照均可" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.phone" />
        </el-form-item>
        <el-form-item label="银行卡号">
          <el-input v-model="form.bank_card" placeholder="从网银复制带空格也可以，保存时会自动去掉" />
        </el-form-item>
        <el-form-item label="开户行">
          <el-input v-model="form.bank_name" placeholder="如：招商银行深圳分行" />
        </el-form-item>
        <el-form-item label="星果ID">
          <el-input v-model="form.xingguo_id" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.note" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer">
      <span class="hint">保存会覆盖该作者原有资料</span>
      <el-button size="small" @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" size="small" :loading="saving" @click="handleSave">保存</el-button>
    </div>
  </el-dialog>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getAuthorProfile, saveAuthorProfile } from '@/api/earnings'

// 作者打款信息的录入表单。
//
// 抽成组件而不是在每个页面各写一份：这是含身份证、银行卡的 PII 表单，
// 两份副本意味着改一处漏一处 —— 比如「回填必须走明文接口」这条约束，
// 漏在某一份里就会把脱敏后的星号串写回库里。
// 目前【作者收益】和【稿费结算】两个页面共用它。
@Component
export default class AuthorProfileDialog extends Vue {
  @Prop({ default: false }) readonly visible!: boolean
  @Prop({ default: 0 }) readonly authorId!: number
  @Prop({ default: '' }) readonly authorName!: string

  loading = false
  saving = false
  form = {
    author_id: 0, real_name: '', id_card: '', phone: '',
    bank_card: '', bank_name: '', xingguo_id: '', note: '',
  }

  get title(): string {
    return this.authorName ? `作者信息 · ${this.authorName}` : '作者信息'
  }

  @Watch('visible')
  onVisibleChange(open: boolean) {
    if (open) this.load()
  }

  async load() {
    if (!this.authorId) return
    this.form = {
      author_id: this.authorId, real_name: '', id_card: '', phone: '',
      bank_card: '', bank_name: '', xingguo_id: '', note: '',
    }
    this.loading = true
    try {
      const res = await getAuthorProfile(this.authorId)
      if (res.found && res.profile) {
        const p = res.profile
        // 必须用明文接口的结果回填，不能用列表里的脱敏值 ——
        // 否则一保存就把 "110***4567" 这种星号串写回了库里
        this.form = {
          author_id: this.authorId,
          real_name: p.real_name || '', id_card: p.id_card || '',
          phone: p.phone || '', bank_card: p.bank_card || '',
          bank_name: p.bank_name || '', xingguo_id: p.xingguo_id || '',
          note: p.note || '',
        }
      }
    } catch (e: any) {
      this.$message.error(e?.response?.data?.message || e?.message || '读取作者资料失败')
      this.$emit('update:visible', false)
    } finally {
      this.loading = false
    }
  }

  async handleSave() {
    if (!this.form.author_id) return
    this.saving = true
    try {
      await saveAuthorProfile({ ...this.form })
      this.$message.success('已保存')
      this.$emit('update:visible', false)
      this.$emit('saved')
    } catch (e: any) {
      this.$message.error(e?.response?.data?.message || e?.message || '保存失败')
    } finally {
      this.saving = false
    }
  }
}
</script>

<style scoped>
.tip {
  margin-bottom: 14px;
}
.hint {
  float: left;
  line-height: 32px;
  font-size: 12px;
  color: #909399;
}
</style>
